import { useSelector } from 'react-redux';
import { IStore } from '../../../interfaces/StoreTypes';
import { getUserInfo } from '../../../utils/user';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { useQuery } from '@tanstack/react-query';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IThinkAnalyticsService } from '@intigral/domain/lib/application/services/ThinkAnalyticsService';
import { transformVOD } from '../../../utils/vodTransformer';
import { isGuestUser } from '../../../config/guestMode';

export const useMoreLikeThis = (itemGuid: string | undefined) => {
    const { config } = useConfigurationSections();
    const profile = useSelector((store: IStore) => store.profile);
    const geolocation = useSelector((store: IStore) => store.location);
    const user = getUserInfo();
    const isGuest = isGuestUser(user);

    const { data, isPending, isError } = useQuery({
        queryKey: ['related-movies', user.username, itemGuid],
        enabled: !!itemGuid && !isGuest,
        queryFn: async () => {
            const taParams: Record<string, string | string[]> = {
                userName: user.username,
                device: 'PC',
                profileName: profile.selectedProfile?.profileName,
                country: geolocation.countryCode,
                rating: profile.selectedProfile?.parentalControl,
                subGuids: user.subscriptionGUID,
                vodGuid: itemGuid,
                itemGuid: itemGuid,
            };

            const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
            const moreLikeThis = await taService.getRelated(user.apiKey, user.identityToken, taParams);
            const otherRelated = await taService.getRelatedOthers(user.apiKey, user.identityToken, taParams);

            return {
                moreLikeThis: moreLikeThis.data.entries.map((e) =>
                    transformVOD({ ...e, media: [{ content: e?.content }] }, config.promotionProviderImages)
                ),
                otherRelated: otherRelated.data?.entries?.map((e) =>
                    transformVOD({ ...e, media: [{ content: e?.content }] }, config.promotionProviderImages)
                ),
            };
        },
        refetchOnWindowFocus: false,
    });

    return {
        isPending,
        isError,
        data,
    };
};
